// extracted by mini-css-extract-plugin
module.exports = {"widget":"style__widget___11ObM","header":"style__header___8AuAg","body":"style__body___1fd8Q","label":"style__label___1xeFS","subtitle":"style__subtitle___3ZDnO"};